







































































































































































































































































































































































































































































































import {
  DataCoreSvcFeedhdlCreateTransactionFeedDTO,
  DataCoreSvcFeedhdlCreateWalletBalanceFeedDTO,
  DataCoreSvcFeedhdlCreateWalletFeedDTO,
  DataCoreSvcFeedhdlFeedScheduleDTO,
  DefaultApi,
} from 'generated/data-core-svc';
import { v4 as uuid } from 'uuid';
import Component from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';

import DataApiManager from '@/api/dataCoreApiManager';
import { BaseVue } from '@/BaseVue';
import UiButton from '@/components/ui/UiButton.vue';
import UiCheckbox from '@/components/ui/UiCheckbox.vue';
import UiDataTable from '@/components/ui/UiDataTable.vue';
import UiDropdown from '@/components/ui/UiDropdown.vue';
import UiFormLabel from '@/components/ui/UiFormLabel.vue';
import UiLoading from '@/components/ui/UiLoading.vue';
import UiSelect2 from '@/components/ui/UiSelect2.vue';
import UiTextEdit from '@/components/ui/UiTextEdit.vue';
import UiTooltip from '@/components/ui/UiTooltip.vue';
import { getEmptyStringProps } from '@/utils/stringUtils';

import { DataSvcFeedRequest, DataSvcSchema } from '../../../generated/data-svc';
import { WalletsQuery } from '../../queries/transactionsPageQuery';
import { getCron } from './FeedCreate.utils';
@Component({
  components: {
    UiButton,
    UiDropdown,
    UiFormLabel,
    UiCheckbox,
    UiTooltip,
    UiLoading,
    UiSelect2,
    UiTextEdit,
    UiDataTable,
  },
  apollo: {
    wallets: {
      query: WalletsQuery,
      variables() {
        if (this.$store.state.currentOrg) {
          return {
            orgId: this.$store.state.currentOrg.id,
          };
        } else {
          return false;
        }
      },
      loadingKey: 'isLoadingWallets',
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'no-cache',
    },
  },
})
export default class FeedCreate extends BaseVue {
  public isLoading = false;
  public isLoadingDataSources = false;
  public isLoadingWallets = 0;
  public isValidating = false;
  public isCreatingFeed = false;

  // Validation related properties
  public validationStatus = ''; // pending, processing, complete, failed
  public validationStep = ''; // preprocessing, validation, etc.
  public validationMessage = ''; // Detailed message about the validation status
  public validationPreviewData: Array<{ [key: string]: any }> = [];
  public validationStatistics: any = null;
  public validationErrors: Array<any> = [];
  public validationWarnings: Array<any> = [];
  public currentFeedId = '';
  public validationCheckInterval: number | null = null;
  public validationStartTime = 0; // Timestamp when validation started
  public feedRunAggregate: any = null; // Store the complete FeedRunAggregate object
  public processedItems = 0;
  public enumeratedItems = 0;
  public isFullyEnumerated = false;
  public stepNames: string[] = [];

  // Properties for data sources
  public loadedDataSources: Array<{ id: string; name: string }> = [];
  public createDataSourceId = '';
  public newDataSourceSchema: any = null;
  public schemas: Array<any> = [];
  public paramsArray: Array<string> = [];
  public newFeedName = '';
  public isExistingDataSource = false;

  @Prop({ default: null })
  public dataSourceId!: string;

  @Prop({ default: false })
  public showExistingDataSourceCheckbox!: boolean;

  @Prop({ default: null })
  public schemaId!: string;

  public dataSource!: { id: string; name: string } | null;
  public wallets: any = [];
  public feedType = 'transaction';
  public schemaType = 'transaction'; // Default to match the default feed type

  // Schedule configuration
  public scheduleType = 'disabled';
  public hasExpiry = false;
  public expiryDate = '';

  // Entity-specific configurations matching backend DTOs
  private entityConfig: { [key: string]: any } = {
    transaction: {
      createWalletsWithNoInternalMapping: false,
    },
    wallet: {
      createDisabled: false,
      updateExistingOnDelta: false,
      createSubsidiariesWithNoInternalMapping: false,
    },
    wallet_balance: {
      createWalletsWithNoInternalMapping: false,
    },
    subsidiary: {
      updateExistingOnDelta: false,
      changelogEnabled: false,
    },
  };

  // UI options for wallet mapping
  private walletMappingOptions: { [key: string]: string } = {
    transaction: 'error',
    wallet_balance: 'error',
  };

  // Coin mapping options
  private coinMappingOptions: { [key: string]: string } = {
    transaction: 'error',
    wallet_balance: 'error',
  };

  /**
   * Get schema type based on the selected feed type
   * This is now an internal method that automatically sets the schema type
   * based on the feed type (1:1 mapping)
   */
  private getSchemaTypeFromFeedType(feedType: string): string {
    // Return appropriate schema type based on feed type
    if (feedType === 'transaction') {
      return 'transaction';
    } else if (feedType === 'wallet') {
      return 'wallet';
    } else if (feedType === 'wallet_balance') {
      return 'wallet_balance';
    } else if (feedType === 'subsidiary') {
      return 'subsidiary';
    }
    return '';
  }

  /**
   * Handle feed type change
   */
  public onFeedTypeChange() {
    // Automatically set schema type based on feed type
    this.schemaType = this.getSchemaTypeFromFeedType(this.feedType);
    console.log(`[FeedCreate] Feed type changed to ${this.feedType}, schema type set to ${this.schemaType}`);
    this.validate();
  }

  /**
   * Handle wallet mapping option change
   */
  onWalletMappingChange(entityType: 'transaction' | 'wallet_balance') {
    const option = this.walletMappingOptions[entityType];
    const config = this.entityConfig[entityType];

    if (option === 'create') {
      // Create new wallets
      config.createWalletsWithNoInternalMapping = true;
    } else if (option === 'error') {
      // Don't create new wallets
      config.createWalletsWithNoInternalMapping = false;
    }
  }

  /**
   * Handle wallet create disabled option change
   */
  public onWalletCreateDisabledChange() {
    console.log(`[FeedCreate] Wallet create disabled option changed to ${this.entityConfig.wallet.createDisabled}`);
    this.validate();
  }

  /**
   * Handle coin mapping option change
   */
  private onCoinMappingChange(entityType: string) {
    // This method is kept for UI state management only
    // The backend options have been removed
    this.coinMappingOptions[entityType] = 'error';
  }

  /**
   * Dynamically generate columns for the preview data table based on the first item's keys
   */
  getPreviewDataColumns() {
    console.log('getPreviewDataColumns called, validationPreviewData:', this.validationPreviewData);
    // If we have preview data, dynamically generate columns based on the first item's keys
    if (this.validationPreviewData && this.validationPreviewData.length > 0) {
      const firstItem = this.validationPreviewData[0];
      console.log('First preview item:', firstItem);
      const keys = Object.keys(firstItem);
      console.log('Keys from first item:', keys);
      const columns = keys.map((key) => ({
        field: key,
        label: key.charAt(0).toUpperCase() + key.slice(1), // Capitalize first letter
        sortable: true,
      }));
      console.log('Generated columns:', columns);
      return columns;
    }
    console.log('No preview data available, returning empty columns array');
    return [];
  }

  public isValidInput = false;
  public status = true;
  public min = 0;
  public max = 6;
  public cron = '0 0 * * *'; // Default cron at midnight daily

  @Prop({ default: true })
  public readonly isCreateButtonVisible!: boolean;

  @Prop({ default: false })
  public readonly disabled!: boolean;

  @Emit('oncreateFeedButtonClick')
  async oncreateFeedButtonClick() {
    const response = await this.createFeed();
    return response;
  }

  generateName(prefix = 'DataSource') {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hour = String(now.getHours()).padStart(2, '0');
    const minute = String(now.getMinutes()).padStart(2, '0');
    return `${prefix}-${year}-${month}-${day}-${hour}-${minute}`;
  }

  public onDataChange() {
    this.paramsArray =
      this.schemas.filter((schema: any) => schema.id === this.newDataSourceSchema?.id)[0]?.params?.split(',') || [];
  }

  public onDataSourceChange() {
    this.updateFeedName();
    this.validate();
  }

  /**
   * Validate the form inputs
   */
  public validate() {
    this.isValidInput = this.validateNameLength(this.newFeedName) && !!this.createDataSourceId && !!this.feedType; // Schema type is now automatically set, so we don't need to check it
    return this.isValidInput;
  }

  /**
   * Validates the length of a name
   * @param name The name to validate
   * @returns True if the name is valid (at least 3 characters)
   */
  public validateNameLength(name: string): boolean {
    return Boolean(name && name.length >= 3);
  }

  public onScheduleChange() {
    // Reset expiry when schedule changes
    if (this.scheduleType === 'disabled') {
      this.hasExpiry = false;
    }
    this.validate();
  }

  public updateFeedName() {
    let feedTypeLabel = 'Transaction';

    // Set the appropriate feed type label based on the selected feed type
    switch (this.feedType) {
      case 'transaction':
        feedTypeLabel = 'Transaction';
        break;
      case 'wallet':
        feedTypeLabel = 'Wallet';
        break;
      case 'wallet_balance':
        feedTypeLabel = 'Wallet Balance';
        break;
      case 'subsidiary':
        feedTypeLabel = 'Subsidiary';
        break;
    }

    if (this.createDataSourceId) {
      const selectedDataSource = this.loadedDataSources.find((ds: any) => ds.id === this.createDataSourceId);
      if (selectedDataSource) {
        this.newFeedName = `${feedTypeLabel} Feed: ${selectedDataSource.name}`;
      } else {
        this.newFeedName = `${feedTypeLabel} Feed`;
      }
    } else {
      this.newFeedName = '';
    }
  }

  async loadDataSources() {
    this.isLoadingDataSources = true;
    try {
      console.log('Loading data sources for organization:', this.orgId, 'and feed type:', this.feedType);
      const ds = DataApiManager.getInstance(true);
      // Map the feed type to the correct schema type expected by the API
      let matchesFeedSchemaType;

      switch (this.feedType) {
        case 'transaction':
          // For transaction feeds, we use the schema type
          if (this.schemaType === 'txn_import') {
            matchesFeedSchemaType = 'import-svc-transaction';
          } else {
            matchesFeedSchemaType = 'transaction';
          }
          break;
        case 'wallet':
          matchesFeedSchemaType = 'wallet';
          break;
        case 'wallet_balance':
          matchesFeedSchemaType = 'wallet_balance';
          break;
        case 'subsidiary':
          // NOTE: matchesFeedSchemaType is a loose/legacy backward-compat filter; confirm the exact value
          // against the running backend during the e2e pass (worst case it just widens the datasource list).
          matchesFeedSchemaType = 'subsidiary';
          break;
      }
      console.log('Using matchesFeedSchemaType:', matchesFeedSchemaType);
      // API method signature has changed - now accepts fewer parameters
      // Set withCredentials in the axios config at the DataApiManager level
      const resp = await ds.handlersDatasourcehdlDataSourceHTTPHandlerList(
        this.orgId,
        matchesFeedSchemaType,
        undefined
      );
      console.log('Data sources API response:', resp);
      if (resp.status === 200) {
        this.loadedDataSources = [];
        if (!resp.data.items || resp.data.items.length === 0) {
          console.warn('No data sources returned from API');
        } else {
          console.log(`Found ${resp.data.items.length} data sources`);
          for (const l of resp.data.items) {
            if (!l.id || !l.name) {
              console.warn('Skipping data source with missing id or name:', l);
              continue;
            }
            console.log('Adding data source:', l);
            this.loadedDataSources.push({
              name: l.name,
              id: l.id,
            });
          }
        }
        this.loadedDataSources.sort((a, b) =>
          (a.name ?? '').localeCompare(b.name ?? '', undefined, { sensitivity: 'base' })
        );
        console.log('Loaded data sources:', this.loadedDataSources);

        // If we're in existing data source mode but have no sources, show a warning
        if (this.isExistingDataSource && this.loadedDataSources.length === 0) {
          this.showErrorSnackbar('No data sources found for the selected feed type. Please create a new data source.');
        }
      } else {
        const e = new Error(`Failed to load data sources. Status Code: ${resp.status}`);
        console.error('Data source API error:', e);
        this.showErrorSnackbar(e.message);
      }
    } catch (error) {
      console.error('Error loading data sources:', error);

      // Extract a user-friendly error message
      let errorMessage = 'Failed to load data sources';
      if (error instanceof Error) {
        errorMessage += `: ${error.message}`;
      } else {
        // Handle axios error objects
        // Use type assertion to any first to avoid TypeScript errors
        const axiosError = error as any;
        if (axiosError && axiosError.response) {
          errorMessage += `: ${axiosError.response.status} - ${axiosError.response.statusText || 'Unknown error'}`;

          // Log additional details for debugging
          if (axiosError.response.data) {
            console.error('API error response data:', axiosError.response.data);
          }
        }
      }

      this.showErrorSnackbar(errorMessage);
    } finally {
      this.isLoadingDataSources = false;
    }
  }

  public async createFeed() {
    this.validate();
    if (this.isValidInput) {
      this.isCreatingFeed = true;
      try {
        // Create schedule object if schedule is enabled
        let schedule: DataCoreSvcFeedhdlFeedScheduleDTO | undefined;
        if (this.scheduleType !== 'disabled') {
          // Create schedule with required properties from DataCoreSvcFeedhdlFeedScheduleDTO
          schedule = {
            type: this.scheduleType,
            enabled: true,
          };

          // Add expiry date if set, converting to Unix timestamp in seconds
          if (this.hasExpiry && this.expiryDate) {
            // Convert date string to Unix timestamp in seconds
            const expiryTimestamp = Math.floor(new Date(this.expiryDate).getTime() / 1000);
            // Use the expiresAtSec field from the DTO
            schedule.expiresAtSec = expiryTimestamp;
          }
        }

        // Get the API instance directly from the generated client to access all methods
        const apiManager = DataApiManager.getInstance(true);

        // The DataCoreApiManager returns an instance of ExtendedDefaultApi which is a DefaultApi
        // We need to cast it to access all the methods
        const api = apiManager as unknown as DefaultApi;
        let res;

        console.log('[FeedCreate] Creating feed with type:', this.feedType);
        console.log('[FeedCreate] Feed schedule:', schedule);

        try {
          // Use the appropriate entity-specific endpoint based on feed type
          if (this.feedType === 'transaction') {
            console.log('[FeedCreate] Using transaction feed endpoint');
            res = await api.handlersFeedhdlFeedHTTPHandlerCreateTransactionFeed(
              this.orgId,
              {
                dataSourceId: this.createDataSourceId,
                name: this.newFeedName,
                createWalletsWithNoInternalMapping: this.entityConfig.transaction.createWalletsWithNoInternalMapping,
                schedule: schedule,
              },
              { withCredentials: true }
            );
          } else if (this.feedType === 'wallet') {
            console.log('[FeedCreate] Using wallet feed endpoint');
            res = await api.handlersFeedhdlFeedHTTPHandlerCreateWalletFeed(
              this.orgId,
              {
                dataSourceId: this.createDataSourceId,
                name: this.newFeedName,
                createDisabled: this.entityConfig.wallet.createDisabled,
                updateExistingOnDelta: this.entityConfig.wallet.updateExistingOnDelta,
                createSubsidiariesWithNoInternalMapping:
                  this.entityConfig.wallet.createSubsidiariesWithNoInternalMapping,
                schedule: schedule,
              },
              { withCredentials: true }
            );
          } else if (this.feedType === 'wallet_balance') {
            console.log('[FeedCreate] Using wallet balance feed endpoint');
            res = await api.handlersFeedhdlFeedHTTPHandlerCreateWalletBalanceFeed(
              this.orgId,
              {
                dataSourceId: this.createDataSourceId,
                name: this.newFeedName,
                createWalletsWithNoInternalMapping: this.entityConfig.wallet_balance.createWalletsWithNoInternalMapping,
                schedule: schedule,
              },
              { withCredentials: true }
            );
          } else if (this.feedType === 'subsidiary') {
            console.log('[FeedCreate] Using subsidiary feed endpoint');
            res = await api.handlersFeedhdlFeedHTTPHandlerCreateSubsidiaryFeed(
              this.orgId,
              {
                dataSourceId: this.createDataSourceId,
                name: this.newFeedName,
                updateExistingOnDelta: this.entityConfig.subsidiary.updateExistingOnDelta,
                changelogEnabled: this.entityConfig.subsidiary.changelogEnabled,
                schedule: schedule,
              },
              { withCredentials: true }
            );
          } else {
            // This should not happen with the current UI, but keeping as a safeguard
            console.error('[FeedCreate] Unknown feed type:', this.feedType);
            throw new Error(`Unsupported feed type: ${this.feedType}`);
          }
        } catch (error) {
          console.error('[FeedCreate] API call error:', error);
          throw error;
        }

        console.log('[FeedCreate] Feed creation response:', res);

        if (res.status === 200) {
          const feedId = res.data?.feedId;
          this.currentFeedId = feedId || '';

          if (this.currentFeedId) {
            // Start validation process
            this.validationStatus = 'pending';
            this.startValidationCheck();

            // Show message that validation is in progress
            this.showSuccessSnackbar(
              `Feed "${this.newFeedName}" created and validation started. Please wait for validation to complete.`
            );
          } else {
            this.showSuccessSnackbar(`Feed "${this.newFeedName}" created successfully, but no feed ID was returned.`);
            this.$emit('onCreated');
          }
        } else {
          this.showErrorSnackbar(`Error creating feed: ${res.statusText || 'Unknown error'}`);
        }
        return res;
      } catch (e) {
        console.error('Error creating feed:', e);
        console.error('[FeedCreate] Feed creation error:', e);
        this.showErrorSnackbar(`Error creating feed: ${(e as Error).message || 'Unknown error'}`);
      } finally {
        // Don't set isCreatingFeed to false until validation is complete
        if (!this.currentFeedId) {
          this.isCreatingFeed = false;
        }
      }
    } else {
      this.showErrorSnackbar('Please fill in all required fields');
    }
  }

  // Start checking validation status periodically with a 5-minute timeout
  private startValidationCheck() {
    // Clear any existing interval
    if (this.validationCheckInterval) {
      clearInterval(this.validationCheckInterval);
      this.validationCheckInterval = null;
    }

    // Check immediately
    this.checkValidationStatus();

    // Set start time for timeout tracking
    this.validationStartTime = Date.now();

    // Then check every 3 seconds, but stop after 5 minutes (300 seconds)
    this.validationCheckInterval = window.setInterval(() => {
      // Check if 5 minutes (300 seconds) have passed
      if (Date.now() - this.validationStartTime > 300000) {
        // Stop checking and show timeout message
        if (this.validationCheckInterval) {
          clearInterval(this.validationCheckInterval);
          this.validationCheckInterval = null;
        }

        // Only update if still in pending state
        if (this.validationStatus === 'pending') {
          this.validationStatus = 'timeout';
          this.validationMessage =
            'Validation timed out after 5 minutes. The process may still be running in the background.';
          this.showErrorSnackbar('Validation is taking longer than expected. You can check the feed status later.');
        }
        return;
      }

      this.checkValidationStatus();
    }, 3000);
  }

  // Check the validation status of the current feed
  private async checkValidationStatus() {
    if (!this.currentFeedId) {
      return;
    }

    try {
      const ds = DataApiManager.getInstance(true);
      const res = await ds.handlersFeedhdlFeedHTTPHandlerGetFeedValidationStatus(this.orgId, this.currentFeedId, {
        withCredentials: true,
      });

      if (res.status === 200 && res.data) {
        // Store the complete FeedRunAggregate object
        this.feedRunAggregate = res.data;

        // Use type assertion to access properties not defined in the generated type
        const responseData = res.data as {
          status?: string;
          step?: string;
          message?: string;
          previewData?: Array<{ [key: string]: any }>;
          statistics?: any;
          errors?: Array<any>;
          warnings?: Array<any>;
          feedRunId?: string;
          FeedRun?: {
            FeedRunId?: string;
            OrgId?: string;
            FeedId?: string;
            ExecutionType?: string;
            Status?: string;
            Message?: string;
            Updates?: Array<any>;
            StepNames?: string[];
            CurrentStepName?: string;
            ProcessedItems?: number;
            EnumeratedItems?: number;
            IsFullyEnumerated?: boolean;
            Warnings?: string[];
            Errors?: string[];
            Preview?: any;
          };
        };

        // Extract data from FeedRunAggregate if available
        if (responseData.FeedRun) {
          // Map FeedRun properties to our component properties
          this.validationStatus = responseData.FeedRun.Status || 'pending';
          this.validationStep = responseData.FeedRun.CurrentStepName || '';
          this.validationMessage = responseData.FeedRun.Message || '';
          this.validationErrors = responseData.FeedRun.Errors || [];
          this.validationWarnings = responseData.FeedRun.Warnings || [];
          this.processedItems = responseData.FeedRun.ProcessedItems || 0;
          this.enumeratedItems = responseData.FeedRun.EnumeratedItems || 0;
          this.isFullyEnumerated = responseData.FeedRun.IsFullyEnumerated || false;
          this.stepNames = responseData.FeedRun.StepNames || [];

          // Handle preview data if available
          console.log('FeedRun Preview data:', responseData.FeedRun.Preview);
          if (responseData.FeedRun.Preview) {
            // Ensure preview data is in the correct format for the UI component
            try {
              let previewData = responseData.FeedRun.Preview;

              // If it's a string, try to parse it as JSON
              if (typeof previewData === 'string') {
                try {
                  previewData = JSON.parse(previewData);
                  console.log('Parsed preview data from string:', previewData);
                } catch (e) {
                  console.error('Failed to parse preview data string:', e);
                }
              }

              // Ensure it's an array
              if (Array.isArray(previewData)) {
                this.validationPreviewData = previewData;
                console.log('Set validationPreviewData from array:', this.validationPreviewData);
              } else if (previewData && typeof previewData === 'object') {
                // If it's an object but not an array, convert it to an array with one item
                this.validationPreviewData = [previewData];
                console.log('Set validationPreviewData from object:', this.validationPreviewData);
              } else {
                console.warn('Preview data is not in a usable format:', previewData);
                this.validationPreviewData = [];
              }
            } catch (e) {
              console.error('Error processing preview data:', e);
              this.validationPreviewData = [];
            }
          } else if (responseData.previewData) {
            // Handle previewData from the response
            try {
              const previewData = responseData.previewData;

              // Ensure it's an array
              if (Array.isArray(previewData)) {
                this.validationPreviewData = previewData;
                console.log(
                  'Set validationPreviewData from responseData.previewData array:',
                  this.validationPreviewData
                );
              } else if (previewData && typeof previewData === 'object') {
                // If it's an object but not an array, convert it to an array with one item
                this.validationPreviewData = [previewData];
                console.log(
                  'Set validationPreviewData from responseData.previewData object:',
                  this.validationPreviewData
                );
              } else {
                console.warn('responseData.previewData is not in a usable format:', previewData);
                this.validationPreviewData = [];
              }
            } catch (e) {
              console.error('Error processing responseData.previewData:', e);
              this.validationPreviewData = [];
            }
          } else {
            console.log('No preview data available');
            this.validationPreviewData = [];
          }
        } else {
          // Fall back to the old format if FeedRun is not available
          this.validationStatus = responseData.status || 'pending';
          this.validationStep = responseData.step || '';
          this.validationMessage = responseData.message || '';

          // Handle preview data in the fallback case using the same robust approach
          if (responseData.previewData) {
            try {
              let previewData = responseData.previewData;

              // If it's a string, try to parse it as JSON
              if (typeof previewData === 'string') {
                try {
                  previewData = JSON.parse(previewData);
                  console.log('Fallback: Parsed preview data from string:', previewData);
                } catch (e) {
                  console.error('Fallback: Failed to parse preview data string:', e);
                }
              }

              // Ensure it's an array
              if (Array.isArray(previewData)) {
                this.validationPreviewData = previewData;
                console.log('Fallback: Set validationPreviewData from array:', this.validationPreviewData);
              } else if (previewData && typeof previewData === 'object') {
                // If it's an object but not an array, convert it to an array with one item
                this.validationPreviewData = [previewData];
                console.log('Fallback: Set validationPreviewData from object:', this.validationPreviewData);
              } else {
                console.warn('Fallback: Preview data is not in a usable format:', previewData);
                this.validationPreviewData = [];
              }
            } catch (e) {
              console.error('Fallback: Error processing preview data:', e);
              this.validationPreviewData = [];
            }
          } else {
            console.log('Fallback: No preview data available');
            this.validationPreviewData = [];
          }

          this.validationStatistics = responseData.statistics || null;
          this.validationErrors = responseData.errors || [];
          this.validationWarnings = responseData.warnings || [];
        }

        // If validation is complete, ready for approval, or failed, stop checking
        // Map the status values from the FeedRunAggregate to our expected values
        const completedStatuses = [
          'Complete',
          'ReadyForApproval',
          'Ready For Approval',
          'Failed',
          'complete',
          'pending_approval',
          'failed',
        ];
        if (completedStatuses.includes(this.validationStatus)) {
          if (this.validationCheckInterval) {
            clearInterval(this.validationCheckInterval);
            this.validationCheckInterval = null;
          }

          // Show appropriate messages based on validation status
          if (
            (this.validationStatus === 'Complete' || this.validationStatus === 'complete') &&
            this.validationErrors.length === 0
          ) {
            this.showSuccessSnackbar('Feed validation completed successfully! You can now approve or reject the feed.');
            // Don't automatically approve - let the user decide
            this.isCreatingFeed = false;
          } else if (
            (this.validationStatus === 'ReadyForApproval' ||
              this.validationStatus === 'Ready For Approval' ||
              this.validationStatus === 'pending_approval') &&
            this.validationErrors.length === 0
          ) {
            this.showSuccessSnackbar(
              'Feed validation completed with warnings. You can now approve or reject the feed.'
            );
            // Don't automatically approve - let the user decide
            this.isCreatingFeed = false;
          } else if (
            this.validationStatus === 'Failed' ||
            this.validationStatus === 'failed' ||
            this.validationErrors.length > 0
          ) {
            this.showErrorSnackbar(`Feed validation failed with ${this.validationErrors.length} errors.`);
            this.isCreatingFeed = false;
          }
        }
      }
    } catch (e) {
      console.error('Error checking validation status:', e);
      // Don't show an error snackbar here as it might be too noisy during polling
    }
  }

  /**
   * Finalizes the feed by approving or rejecting it
   */
  async finalizeFeed(approve: boolean) {
    if (!this.currentFeedId) {
      return;
    }

    try {
      this.isCreatingFeed = true;

      // Use the proper API endpoint to update the feed approval status
      const ds = DataApiManager.getInstance(true);
      const response = await ds.handlersFeedhdlFeedHTTPHandlerUpdateFeedApproval(
        this.orgId,
        this.currentFeedId,
        {
          approved: approve,
          reason: approve ? '' : 'Feed rejected by user',
        },
        { withCredentials: true }
      );

      if (response.status === 200) {
        // Show success notification
        this.showSuccessSnackbar(approve ? 'Feed approved successfully!' : 'Feed rejected successfully!');

        // Emit event to parent component
        this.$emit('feedFinalized', {
          feedId: this.currentFeedId,
          approved: approve,
        });

        // Reset the component state if needed
        if (!approve) {
          this.resetValidationState();
        }

        // On approve, bump the user to the feed's detail page so they land on the now-approved feed.
        // (Pushing the feeds-list route was a no-op: this form is embedded in that same route, so
        // router.push to it is a NavigationDuplicated and the form just stayed open.)
        if (approve) {
          this.$router.push(`/dataV2/feeds/${this.currentFeedId}`);
        }
      } else {
        // Show error notification
        this.showErrorSnackbar(`Failed to ${approve ? 'approve' : 'reject'} feed: ${response.statusText}`);
      }
    } catch (error) {
      console.error('Error finalizing feed:', error);
      // Show error notification
      this.showErrorSnackbar(
        `Error ${approve ? 'approving' : 'rejecting'} feed: ${(error as Error).message || 'Unknown error'}`
      );
    } finally {
      this.isCreatingFeed = false;
    }
  }

  /**
   * Resets the validation state
   */
  resetValidationState() {
    this.validationStatus = '';
    this.validationStep = '';
    this.validationMessage = '';
    this.validationPreviewData = [];
    this.validationStatistics = null;
    this.validationErrors = [];
    this.validationWarnings = [];
    this.currentFeedId = '';
    this.feedRunAggregate = null;
    this.processedItems = 0;
    this.enumeratedItems = 0;
    this.isFullyEnumerated = false;
    this.stepNames = [];
  }

  /**
   * Lifecycle hook - called when component is created
   */
  created() {
    console.log('FeedCreate component created');
    // Initialize data sources
    this.loadDataSources();

    // Initialize UI options based on entity config defaults
    this.initializeUIOptions();
  }

  /**
   * Initialize UI options based on entity config
   */
  private initializeUIOptions() {
    // For each entity type
    (['transaction', 'wallet_balance'] as const).forEach((entityType) => {
      const config = this.entityConfig[entityType];

      // Set wallet mapping option based on createWalletsWithNoInternalMapping
      if (config.createWalletsWithNoInternalMapping) {
        this.walletMappingOptions[entityType] = 'create';
      } else {
        this.walletMappingOptions[entityType] = 'error';
      }

      // Default to 'error' for coin mapping
      this.coinMappingOptions[entityType] = 'error';
    });
  }

  /**
   * Returns a user-friendly label for the current feed type
   */
  public getFeedTypeLabel(): string {
    switch (this.feedType) {
      case 'transaction':
        return 'Transaction';
      case 'wallet':
        return 'Wallet';
      case 'wallet_balance':
        return 'Wallet Balance';
      case 'subsidiary':
        return 'Subsidiary';
      default:
        return 'Data';
    }
  }
}
